import React from 'react';
import { Skeleton } from 'components/_shared/Skeleton';
import { formatCoverage, coverageOf, fieldHeaderStats } from '../../fields.utils';
import { Header, Name, Stats, Stat, Value, Label, Sub, Note } from './FieldHeader.styles';

const NO_VALUE = '—';

export const FieldHeader = ({
  field,
  detail,
  survey,
  surveyDetail,
  isRecord,
  draft,
  isDetailLoading
}) => {
  const coverage = survey ? survey.coverage_ratio : coverageOf(field);
  const precision = detail?.coverage_precision;
  const isBand = (precision?.max_undercount ?? 0) > 0;
  const acres =
    isRecord && surveyDetail ? surveyDetail.survey.area_acres : field.area_acres;

  const stats = survey
    ? fieldHeaderStats({
        acres,
        survey,
        isRecord,
        draft,
        densityConfidence: detail?.field.density_confidence
      })
    : null;

  const coverageLabel = () => {
    if (coverage == null) return 'no coverage measured in this survey yet';
    return isRecord
      ? 'imaged when this survey closed'
      : 'of the field imaged in this survey';
  };

  return (
    <Header>
      <Name>{field.name}</Name>
      <Stats>
        <Stat>
          <Value>{Math.round(acres).toLocaleString()}</Value>
          <Label>acres</Label>
        </Stat>
        <Stat>
          {isDetailLoading ? (
            <Skeleton height='24px' width='80px' />
          ) : (
            <Value $tone={coverage == null ? undefined : 'good'}>
              {coverage == null ? NO_VALUE : formatCoverage(coverage, precision)}
            </Value>
          )}
          <Label>{coverageLabel()}</Label>
        </Stat>
        {stats && (
          <>
            <Stat>
              <Value $tone='warm'>{stats.stones.value}</Value>
              <Label>{stats.stones.label}</Label>
              {stats.stones.sub && <Sub>{stats.stones.sub}</Sub>}
            </Stat>
            <Stat>
              <Value $tone='warm'>{stats.density.value}</Value>
              <Label>{stats.density.label}</Label>
              {stats.density.sub && <Sub>{stats.density.sub}</Sub>}
            </Stat>
          </>
        )}
      </Stats>
      <Note>
        Every stone here was checked by SoilMate before it reached you.
        {isBand && coverage != null && (
          <>
            {' '}
            Coverage is every pass in this survey combined, from one GPS fix every{' '}
            {precision.sample_interval_s} seconds, so it reads a little low on ground that
            was worked.
          </>
        )}
      </Note>
    </Header>
  );
};
